import script from "./ManagementMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementMain.vue?vue&type=script&setup=true&lang=js"

import "./ManagementMain.vue?vue&type=style&index=0&id=555faa55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-555faa55"]])

export default __exports__